module.exports = __webpack_public_path__ + "serbia.svg?5508bcdd8d07a20f4251743905bc8fe9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/serbia.svg
// module id = 288
// module chunks = 10